import React, { Component } from 'react';

class Gallery extends Component {

    componentDidMount(){
        document.body.className = "default";
	}

    render() {
        return (
            <div>
                <div class="opis-zw">
		            <h1 class="nagl">Galeria</h1>
	            </div>

                <div class="zdjecia">
		            <img className="gal" src="/assets/img/recepcja.JPG" />
		            <img className="gal" src="/assets/img/IMG_0217_2.JPG" />
		            <img className="gal" src="/assets/img/IMG_2031.JPG" />
		            <img className="gal" src="/assets/img/IMG_3377.JPG" />
		            <img className="gal" src="/assets/img/IMG_3378.JPG" />
		            <img className="gal" src="/assets/img/IMG_3403.JPG" />
		            <img className="gal" src="/assets/img/IMG_3441_2.JPG" />
		            <img className="gal" src="/assets/img/IMG_3476.JPG" />
		            <img className="gal" src="/assets/img/IMG_3479.JPG" />
		            <img className="gal" src="/assets/img/IMG_3484.JPG" />
		            <img className="gal" src="/assets/img/IMG_3488.JPG" />
	            </div>
            </div>
            
	
        )   
    }
}
export default Gallery;